// extracted by mini-css-extract-plugin
export var avatarContainer = "_53-0";
export var avatarTypingWave = "_53-i";
export var gray = "_53-f";
export var green = "_53-c";
export var icon = "_53-9";
export var image = "_53-1";
export var lg = "_53-6";
export var md = "_53-5";
export var presenceDot = "_53-b";
export var red = "_53-d";
export var sm = "_53-4";
export var status = "_53-a";
export var typingDot = "_53-h";
export var typingPill = "_53-g";
export var xl = "_53-7";
export var xs = "_53-3";
export var xxl = "_53-8";
export var xxs = "_53-2";
export var yellow = "_53-e";